'use client';

import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

/**
 * This component runs an effect after a user login
 * which refreshes the content data from the nextJS server.
 *
 * This is necessary because the content is now filtered serverside,
 * but after a use login there may be different content for the user.
 */
export const RefreshContentAfterLogin = () => {
  const { loggedIn } = useLoginState();
  const originalLoginState = useRef(loggedIn);

  const router = useRouter();

  useEffect(() => {
    // Refresh is only needed if the user was anonymous when the page loaded and is now logged in.
    if (loggedIn && originalLoginState.current === false) {
      // refreshes data from nextJS server
      router.refresh();
      originalLoginState.current = !originalLoginState.current;
    }
  }, [loggedIn, router]);

  return null;
};
